import React, { useState } from "react";
import {
    Modal,
    ModalOverlay,
    ModalContent,
    ModalHeader,
    ModalCloseButton,
    ModalBody,
    Button,
    Textarea,
    VStack,
    useToast,
} from "@chakra-ui/react";
import { appStore, postStore } from "../../zustand/globalStore";
import i18n from "../../i18n/i18n";
import { consumeApi } from "../../utils/tools";
import { colors } from "../../definitions/constants/GlobalStyles";

export function SharePostModalComponent() {
    const { isShareModalOpen, setIsShareModalOpen, selectedPost } = postStore(
        (state) => state
    );
    const { userData } = appStore((state) => state);
    const toast = useToast();
    const [commentText, setCommentText] = useState("");
    const [isSaving, setIsSaving] = useState(false);

    const handleClose = () => {
        setIsShareModalOpen(false);
        setCommentText("");
    };

    const handleShare = async () => {
        if (!userData || !selectedPost) return;
        setIsSaving(true);
        try {
            const response = await consumeApi("posts/share_post", "POST", {
                user_id: userData.id,
                original_post_id: selectedPost.id,
                post_text: commentText.trim(),
            });
            if (response?.status === "success") {
                toast({
                    title: i18n.t("Post shared successfully"),
                    status: "success",
                    duration: 3000,
                    isClosable: true,
                });
                handleClose();
            } else {
                throw new Error(response?.message || "Failed to share");
            }
        } catch (error) {
            toast({
                title: i18n.t("Error sharing post"),
                status: "error",
                duration: 3000,
                isClosable: true,
            });
        } finally {
            setIsSaving(false);
        }
    };

    return (
        <Modal isOpen={isShareModalOpen} onClose={handleClose} isCentered>
            <ModalOverlay bg="blackAlpha.300" backdropFilter="blur(10px)" />
            <ModalContent borderRadius="20px" mx={4}>
                <ModalHeader>{i18n.t("Share Post")}</ModalHeader>
                <ModalCloseButton />
                <ModalBody pb={6}>
                    <VStack spacing={4}>
                        <Textarea
                            value={commentText}
                            onChange={(e) => setCommentText(e.target.value)}
                            placeholder={i18n.t("Write something about this...")}
                            size="sm"
                            resize="none"
                            focusBorderColor={colors.figmaColors.secColor}
                            borderRadius="10px"
                            rows={4}
                        />
                        <Button
                            bg={colors.figmaColors.secColor}
                            color="white"
                            width="100%"
                            borderRadius="20px"
                            isLoading={isSaving}
                            onClick={handleShare}
                            _hover={{ opacity: 0.8 }}
                        >
                            {i18n.t("Share Now")}
                        </Button>
                    </VStack>
                </ModalBody>
            </ModalContent>
        </Modal>
    );
}

export default SharePostModalComponent;
